import styled, { css } from 'styled-components/macro';

export const textColor = css<{ error?: boolean; disabled?: boolean }>`
  color: ${({ theme, error, disabled }) => {
    const { colors } = theme;
    if (error) {
      return colors.negative_dark;
    }
    if (disabled) {
      return colors.black_40;
    }

    return colors.black_80;
  }};
`;

export const Label = styled.label<{ label?: string; margin?: string }>`
  display: block;
  height: ${({ label }) => (!!label ? 'auto' : '16px')};
  margin-bottom: ${({ theme }) => theme.spacing.zero_2};

  ${({ margin }) => margin && `margin: ${margin}`};

  ${textColor};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  line-height: ${({ theme }) => theme.lineHeight.one};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    height: ${({ label }) => (!!label ? 'auto' : '0')};
    margin-bottom: ${({ label, theme }) => (!!label ? theme.spacing.zero_1 : theme.spacing.zero)};
  }
`;

export const Asterisk = styled.i<{ disabled?: boolean }>`
  color: ${({ theme, disabled }) =>
    disabled ? theme.colors.black_40 : theme.colors.negative_dark};
  font-style: normal;
`;
